import { Component, Host, h, Prop } from "@stencil/core";

import { Font } from "../../index";

/**
 * @slot - Slot for text and icons
 * @slot icon - Slot for icon that should be on left side of the text (not inline)
 */
@Component({
  tag: "stzh-text",
  styleUrl: "stzh-text.scss",
  scoped: true,
})
export class StzhText {
  /** Font used */
  @Prop() font: Font.Fonts = "default";

  /** Type of curve (see [Spacings docs page](/docs/tokens-typography--docs#curves) for more info). */
  @Prop({ reflect: true }) curve: Font.Curves = "default";

  /** Whether if text is lead text */
  @Prop({ reflect: true }) lead: boolean = false;

  /** Color used */
  @Prop({ reflect: true }) color: "default" | "primary" | "secondary" | "info" | "inherit" = "default";

  /** Manually overwrite font size applied by curve attribute (see [Spacings docs page](/docs/tokens-typography--docs#sizes) for more info). */
  @Prop() size: Font.Sizes | "inherit" = "inherit";
  /** Manually overwrite font size applied by curve attribute above small breakpoint (see [Spacings docs page](/docs/tokens-typography--docs#sizes) for more info). */
  @Prop() sizeSmall: Font.Sizes | "inherit" = "inherit";
  /** Manually overwrite font size applied by curve attribute above medium breakpoint (see [Spacings docs page](/docs/tokens-typography--docs#sizes) for more info). */
  @Prop() sizeMedium: Font.Sizes | "inherit" = "inherit";
  /** Manually overwrite font size applied by curve attribute above large breakpoint (see [Spacings docs page](/docs/tokens-typography--docs#sizes) for more info). */
  @Prop() sizeLarge: Font.Sizes | "inherit" = "inherit";
  /** Manually overwrite font size applied by curve attribute above ultra breakpoint (see [Spacings docs page](/docs/tokens-typography--docs#sizes) for more info). */
  @Prop() sizeUltra: Font.Sizes | "inherit" = "inherit";

  render() {
    return (
      <Host>
        <div
          class={{
            "stzh-text": true,
            "stzh-text--is-lead": this.lead,
            [`stzh-text--font-${this.font}`]: !!this.font,
            [`stzh-text--curve-${this.curve}`]: !!this.curve,
            [`stzh-text--size-${this.size}`]: !!this.size,
            [`stzh-text--size-small-${this.sizeSmall}`]: !!this.sizeSmall,
            [`stzh-text--size-medium-${this.sizeMedium}`]: !!this.sizeMedium,
            [`stzh-text--size-large-${this.sizeLarge}`]: !!this.sizeLarge,
            [`stzh-text--size-ultra-${this.sizeUltra}`]: !!this.sizeUltra,
          }}
        >
          <div class="stzh-text__text">
            <div class="stzh-text__icon">
              <slot name="icon"></slot>
            </div>
            <div class="stzh-text__text-inner">
              <slot></slot>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
